import { useQuery } from '@tanstack/react-query';
import { getCustomSurveyResults } from '../../api/customSurveys';

export enum GetCustomSurveyResultsCacheKey {
  CustomSurveyResults = 'customSurveyResults',
}

export const useGetCustomSurveyResultsQuery = (surveyId: number) => {
  return useQuery({
    queryKey: [GetCustomSurveyResultsCacheKey.CustomSurveyResults, surveyId],
    queryFn: () => getCustomSurveyResults(surveyId),
    enabled: Boolean(surveyId),
  });
};
